import React from "react"
import { Piece } from "./piece"

export function CantiDomenicaPiece({ props, setProps, tools }) {
  return <Piece name="Libretto messa e canti" tools={tools} />
}

CantiDomenicaPiece.cmsName = "Libretto messa e canti"
CantiDomenicaPiece.cmsProtected = true